// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AudioProvider } from './context/AudioContext';
import { LibraryProvider } from './context/LibraryContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import DiscographyPage from './pages/DiscographyPage';
import AboutPage from './pages/AboutPage';

function App() {
  return (
    <Router>
      <AudioProvider>
        <LibraryProvider>
          <div className="min-h-screen flex flex-col bg-gray-900 text-gray-100">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/discography" element={<DiscographyPage />} />
                <Route path="/about" element={<AboutPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </LibraryProvider>
      </AudioProvider>
    </Router>
  );
}

export default App;